import "core-js/modules/es6.array.index-of";
export function hasClass(el, str) {
  return el.className.indexOf(str) >= 0;
}